import { Component, ElementRef, ViewChild } from "@angular/core";
import { NavParams, ToastController, ViewController } from "ionic-angular";
import moment from "moment";
import { TagEntry } from "../../models/trend-live-models/TagEntry";
import * as Plotly from "plotly.js";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Signaltag } from "../../models/trend-live-models/OPTag";
import { map } from "rxjs/operators";
import { StarmsClientProvider } from "../../providers/starms-client/starms-client";
import { Train } from "../../models";
import { forkJoin } from "rxjs-compat/observable/forkJoin";
import { DEFAULT_TIME_FORMAT } from "../../models/trend-live-models/TimeRange";

/**
 * Generated class for the PerformanceDetailsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "performance-details",
  templateUrl: "performance-details.html",
})
export class PerformanceDetailsComponent {
  @ViewChild("chartPerf", { read: ElementRef }) chartRef: ElementRef;

  performWashAdvise: string;
  timeRange = 30;

  timeForm: FormGroup;
  _config;

  customTimeForm;
  text: string;
  ready = false;
  lastValue: any;
  firstValue: any;
  lastTimeStamp: any;
  agtPerformanceAdvise: string;
  tagName: any;
  performanceReady: boolean;
  agtPerformanceMeta: { bandTop: any; bandBottom: any };
  agtPerformanceDegradation = [
    {
      tagName: "A54MW_D2MLM",
      tagDescription: "",
      tagId: null,
      tagData: [],
    },
    {
      tagName: "A54MW_D2MLM_AVG",
      isStep: false,
      tagDescription: "",
      tagId: null,
      tagData: [],
    },
  ];
  constructor(
    private viewCtrl: ViewController,
    params: NavParams,
    private fb: FormBuilder,
    private starms: StarmsClientProvider,
    private toastCtrl: ToastController
  ) {
    this._config = params.data;
    console.log(
      "🚀 ~ file: performance-details.ts ~ line 70 ~ PerformanceDetailsComponent ~ this._config",
      this._config
    );
    let config = params.data;
    this.timeForm = this.fb.group({
      displayFrom: moment(this._config.lastDate, "DD-MMM-YYYY HH:mm")
        .subtract(this.timeRange, "d")
        .format("YYYY-MM-DD"),
      displayTo: moment(this._config.lastDate, "DD-MMM-YYYY HH:mm").format(
        "YYYY-MM-DD"
      ),
    });
    this.customTimeForm = {
      from: moment(this._config.lastDate, "DD-MMM-YYYY HH:mm")
        .subtract(this.timeRange, "d")
        .format(DEFAULT_TIME_FORMAT),
      to: moment(this._config.lastDate, "DD-MMM-YYYY HH:mm").format(
        DEFAULT_TIME_FORMAT
      ),
    };
    console.log("on init");
    this.getAGTPerformanceTags(this.customTimeForm);
  }

  presentToast() {
    let toast = this.toastCtrl.create({
      message: "Invalid selected date!",
      duration: 2000,
      position: "bottom",
    });

    toast.present();
  }

  changedFrom(from) {
    console.log("changed from", from);
    this.performanceReady = false;
    let momentFrom = moment()
      .year(from.year)
      .month(from.month - 1)
      .date(from.day);
    let momentTo = moment(this.customTimeForm.to);

    if (momentFrom > momentTo) {
      this.performanceReady = true;
      this.presentToast();
    }
    this.customTimeForm.from = momentFrom.format(DEFAULT_TIME_FORMAT);
    // this.customTimeForm.value.displayFrom = momentFrom.format('YYYY-MM-DD');

    this.getAGTPerformanceTags(this.customTimeForm);
  }

  changedTo(to) {
    console.log("changed to", to);

    this.performanceReady = false;
    let momentTo = moment()
      .year(to.year)
      .month(to.month - 1)
      .date(to.day);
    let momentFrom = moment(this.customTimeForm.from);

    if (momentFrom > momentTo) {
      this.performanceReady = true;
      this.presentToast();
    }
    this.customTimeForm.to = momentTo.format(DEFAULT_TIME_FORMAT);
    this.customTimeForm.displayTo = momentTo.format("YYYY-MM-DD");

    this.getAGTPerformanceTags(this.customTimeForm);
  }

  //added 26 hours to the 'to' timestamp to cover all global time zones
  coverGlobalTimeZones(to: string) {
    let toDate = moment(to).add(26, "hours");
    let formattedToDate = toDate.format("YYYY-MM-DD HH:mm:ss");

    return formattedToDate.toString();
  }
  /**
   * Map agt perfromance tags to sta-rms tags
   */
  getAGTPerformanceTags(timeRange?) {
    // Get meta data for yellow band
    this.starms
      .get([
        "metadata",
        "assemblies",
        (this._config.entity as Train).assemblyId,
      ])
      .pipe(
        map((rawMetaData: any[]) => {
          let myHealthMeta = rawMetaData.filter(
            (entry) => entry.namespace == "myHealth"
          );

          if (myHealthMeta.length == 2) {
            let bandBottom = myHealthMeta.find(
              (el) => el.parameterName === "Degradation Level 2"
            );
            let bandTop = myHealthMeta.find(
              (el) => el.parameterName === "Degradation Level 1"
            );
            if (bandBottom !== undefined && bandTop !== undefined) {
              return { bandBottom, bandTop };
            } else {
              throw Error("Band is not defined");
            }
          } else {
            throw Error("Band is not defined");
          }
        })
      )
      .subscribe(() => {
        this.agtPerformanceMeta = this._config.bandLimits;
        let metaData = {
          bandBottom: this._config.bandLimits[0].startYellowBand,
          bandTop: this._config.bandLimits[1].startRedBand,
        };
        this.agtPerformanceMeta = metaData;
        // Get tags
        console.log("time", this.customTimeForm);
        this.starms
          .get(["signals", "signaltags", "trains", this._config.entity.getId()])
          .pipe(
            map((response: any[]) => {
              return response.map((entry) =>
                new Signaltag().deserialize(entry)
              );
            })
          )
          .subscribe((tags) => {
            // Check performance tags availability
            for (let agtTag of this.agtPerformanceDegradation) {
              let index = tags.findIndex(
                (tag) => tag.tagName === agtTag.tagName
              );
              if (index > -1) {
                agtTag.tagId = tags[index].tagId;
              }
            }
            // Get each performance tag values
            forkJoin(
              ...this.agtPerformanceDegradation.map((agtTag) => {
                if (timeRange == undefined) {
                  return this.starms.get(["signals/tags", agtTag.tagId], {
                    filter: "optim",
                    // added 12 hours to the 'to' timestamp to cover all global time zones
                    to: this.coverGlobalTimeZones(
                      moment(this.customTimeForm.to).format(DEFAULT_TIME_FORMAT)
                    ),
                    from: moment(this.customTimeForm.from).format(
                      DEFAULT_TIME_FORMAT
                    ),
                    // from: '2021-10-01 14:56:55',
                    // to: '2021-10-03 14:56:55'
                  });
                } else {
                  return this.starms.get(["signals/tags", agtTag.tagId], {
                    filter: "optim",
                    // added 12 hours to the 'to' timestamp to cover all global time zones
                    to: this.coverGlobalTimeZones(
                      moment(this.customTimeForm.to).format(DEFAULT_TIME_FORMAT)
                    ),
                    from: moment(this.customTimeForm.from).format(
                      DEFAULT_TIME_FORMAT
                    ),
                    // from: '2021-10-01 14:56:55',
                    // to: '2021-10-03 14:56:55'
                  });
                }
              })
            )
              .pipe(
                map((rawTags: any[]) => {
                  return [
                    ...rawTags.map((rawTag) => {
                      let tag = new Signaltag().deserialize(rawTag);
                      //tag.tagData = tag.tagData.filter(x => x.value !== null);
                      return tag;
                    }),
                  ];
                })
              )
              .subscribe(([tag1, tag2]) => {
                this.agtPerformanceDegradation[0].tagData = tag1.tagData;
                this.agtPerformanceDegradation[1].tagData = tag2.tagData;

                this.agtPerformanceDegradation[0].tagDescription =
                  tag1.tagIndex.description;
                this.agtPerformanceDegradation[1].tagDescription =
                  tag2.tagIndex.description;

                this._config.agtTags = this.agtPerformanceDegradation;
                let lastValue;

                console.log(
                  "🚀 ~ file: performance-details.ts ~ line 266 ~ PerformanceDetailsComponent ~ .subscribe ~ this.agtPerformanceDegradation[2]",
                  this.agtPerformanceDegradation
                );

                if (!tag2.tagData.every((val) => val.value == null)) {
                  this.firstValue = tag2.tagData.find(
                    (x) => x.value !== null
                  ).value;
                  lastValue = tag2.tagData
                    .filter((x) => x.value != null)
                    .slice(-1)[0].value;
                }

                if (lastValue == undefined) {
                  this.agtPerformanceAdvise = "No data";
                  this.performWashAdvise = "nodata";
                } else {
                  if (
                    lastValue > metaData.bandBottom.value &&
                    lastValue < metaData.bandTop.value
                  ) {
                    let decreasedValue = this.firstValue - lastValue;
                    this.agtPerformanceAdvise =
                      "Your performance decreased " +
                      Math.round(decreasedValue * 10) / 10 +
                      " kW";
                    this.performWashAdvise = "yellow";
                  } else if (lastValue < metaData.bandBottom.value) {
                    this.agtPerformanceAdvise = "Compressor wash advised";
                    this.performWashAdvise = "red";
                  } else {
                    this.agtPerformanceAdvise =
                      "Engine is running as expected with no appreciable degradation";
                    this.performWashAdvise = "green";
                  }
                }

                this.performanceReady = true;
                this.createPlotChart();
                this.updateLayout();
              });
          });
      });
  }

  createPlotChart() {
    var trace = this.createTrace();
    console.log(
      "🚀 ~ file: performance-details.ts ~ line 309 ~ PerformanceDetailsComponent ~ createPlotChart ~ trace",
      trace
    );

    var layout = {
      // height: 300,
      // width: 350,
      margin: { t: 20, r: 0, l: 40, b: 0, pad: 0 },
      //hovermode: false,
      hovermode: "closest",
      legend: {
        orientation: "h",
        font: {
          size: 10,
        },
      },
      // title: 'Estimated power availability relative to average new and clean engine',
      xaxis: {
        type: "date",
        showspikes: true,
        showgrid: true,
        tickfont: {
          family: "Siemens Slab",
          size: 12,
          color: "#4d217a", // purple
        },
      },
      yaxis: {
        title: {
          text: "Performance",
          font: {
            family: "Siemens Slab",
            size: 12,
          },
          xref: "paper",
          x: 0.05,
        },
        autorange: true,
        range: [-4000, 6000],
        type: "linear",
      },
      shapes: this.createAreaShapes(),
    };
    var config = {
      displayModeBar: false,
    };
    Plotly.newPlot(this.chartRef.nativeElement, trace, layout, config);
  }

  updateLayout() {
    var update = {
      shapes: this.createAreaShapes(),
    };
    Plotly.relayout(this.chartRef.nativeElement, update);
  }

  createTrace() {
    return [
      {
        x: [
          ...(this._config.agtTags[0].tagData as Array<TagEntry>).map((t) =>
            moment.utc(t.timestamp).format()
          ),
        ],
        y: [
          ...(this._config.agtTags[0].tagData as Array<TagEntry>).map(
            (entry) => entry.value
          ),
        ],
        // mode: 'lines',
        line: { color: "#DA1E28" }, // red
        mode: "markers",
        type: "scatter",
        name: this._config.agtTags[0].tagDescription,
        connectgaps: false,
      },
      {
        x: [
          ...(this._config.agtTags[1].tagData as Array<TagEntry>).map((t) =>
            moment.utc(t.timestamp).format()
          ),
        ],
        y: [
          ...(this._config.agtTags[1].tagData as Array<TagEntry>).map(
            (entry) => entry.value
          ),
        ],
        // mode: 'lines',
        line: { shape: "hv", color: "#0057C6" }, // blue
        mode: "lines",
        type: "scatter",
        name: this._config.agtTags[1].tagDescription,
        connectgaps: false,
      },
    ];
  }

  createAreaShapes() {
    let tagMin = Math.min(
      ...this._config.agtTags[1].tagData.map((x) => x.value)
    );
    let tagMax = Math.max(
      ...this._config.agtTags[1].tagData.map((x) => x.value)
    );
    let bandBottom = this.agtPerformanceMeta.bandBottom.value;
    let bandTop = this.agtPerformanceMeta.bandTop.value;

    let redBottom = bandBottom < tagMin ? bandBottom - 2000 : tagMin - 2000;
    let greenTop = bandTop > tagMax ? bandTop + 2000 : tagMax + 2000;
    return [
      {
        type: "rect",
        layer: "below",
        // x-reference is assigned to the x-values
        xref: "paper",
        // y-reference is assigned to the plot paper [0,1]
        yref: "y",
        x0: 0,
        y0: redBottom,
        x1: 1,
        y1: bandBottom,
        fillcolor: "#DA1E28", // red
        opacity: 0.2,
        line: {
          width: 0,
        },
      },
      {
        type: "rect",
        layer: "below",
        // x-reference is assigned to the x-values
        xref: "paper",
        // y-reference is assigned to the plot paper [0,1]
        yref: "y",
        x0: 0,
        y0: bandBottom,
        x1: 1,
        y1: bandTop,
        fillcolor: "#FFF91F", // yellow
        opacity: 0.2,
        line: {
          width: 0,
        },
      },
      {
        type: "rect",
        layer: "below",
        // x-reference is assigned to the x-values
        xref: "paper",
        // y-reference is assigned to the plot paper [0,1]
        yref: "y",
        x0: 0,
        y0: bandTop,
        x1: 1,
        y1: greenTop,
        fillcolor: "#00FD79", // green
        opacity: 0.2,
        line: {
          width: 0,
        },
      },
    ];
  }

  dismiss(): void {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/components/performance-details/performance-details.ts